module.exports = __webpack_public_path__ + "static/img/home_robot_sdk.56c46d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/home_robot_sdk.png
// module id = 1405
// module chunks = 1